import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, Box } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@orijinworks/frontend-commons';
import { AutocompleteSkeleton, AutocompleteOption } from '../../AttorneyModal/sections';
import {
  membersAutocompleteSx,
  searchIcon,
} from '../../AttorneyModal/AttorneyModal.styles';
import { useAutocompleteStyles } from './MemberAutocomplete.styles';
import { useMemberAutocomplete } from './useMemberAutocomplete';

const MemberAutocomplete = ({
  memberOptions = [],
  selectedMembers = [],
  inputValue,
  onMembersChange,
  onSearchChange,
  isMaxMembersReached = false,
  isMemberListLoading = false,
  showDisplayNamesOnly = false,
  filterOptions,
  getOptionLabel,
  isOptionEqualToValue,
  multiple = true,
  disabled = false,
  label = 'Members',
  placeholder = 'Search',
  helperText,
  rootClassName = 'member-autocomplete-root',
}) => {
  const classes = useAutocompleteStyles();
  const { handleChange, handleInputChange, handleKeyDown, getOptionProps, popperProps } =
    useMemberAutocomplete({
      memberOptions,
      selectedMembers,
      onMembersChange,
      onSearchChange,
      showDisplayNamesOnly,
    });

  return (
    <Box className={rootClassName}>
      <Autocomplete
        multiple={multiple}
        options={memberOptions}
        value={selectedMembers}
        inputValue={inputValue !== undefined ? inputValue : undefined}
        disabled={disabled || isMaxMembersReached}
        disableClearable={true}
        disableCloseOnSelect={false}
        disablePortal={false}
        freeSolo={!multiple}
        noOptionsText={null}
        getOptionLabel={getOptionLabel}
        filterOptions={filterOptions}
        isOptionEqualToValue={isOptionEqualToValue}
        renderTags={() => null}
        onChange={handleChange}
        onInputChange={handleInputChange}
        className={classes.autocompleteRoot}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            variant="outlined"
            helperText={helperText}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={searchIcon} />
                </InputAdornment>
              ),
              endAdornment: params.InputProps?.endAdornment || null,
            }}
            onKeyDown={handleKeyDown}
            sx={membersAutocompleteSx}
          />
        )}
        PopperProps={popperProps}
        renderOption={(option) => {
          const optionProps = getOptionProps(option);
          return <AutocompleteOption {...optionProps} />;
        }}
        ListboxComponent={({ children, ...other }) => (
          <div {...other}>
            {isMemberListLoading ? <AutocompleteSkeleton /> : children}
          </div>
        )}
      />
    </Box>
  );
};

export default MemberAutocomplete;
